<template>
  <div>
    <div class="users-layout">
      <default-box
          :loader="loading">
        <router-view/>
        <div class="d-flex justify-content-between align-items-center mb-10">

        </div>
        <tables-slot
            :empty_spacer="loading"
            @paginationFetch="fillData"
            @popstateEvent="fetchList"
            :pagination="pagination">
          <template v-slot:table_head>
            <td class="w-0 text-nowrap">#</td>
            <td class="w-0 text-nowrap">{{ $t('tables.title') }}</td>
            <td class="w-0 text-nowrap">{{ $t('belts.description') }}</td>
            <td class="w-0 text-nowrap" v-if="getUserRoleIsAdmin">{{ $t('tables.edit') }}</td>
          </template>
          <template v-slot:table_body>
            <tr v-for="benefit in benefits">
              <td class="w-0 text-nowrap">
                {{ benefit.id }}
              </td>
              <td class="w-0 text-nowrap">
                {{ benefit.title }}
              </td>
              <td class="w-0 text-nowrap">
                {{ benefit.description }}
              </td>
              <td class="w-0 text-nowrap">
                <router-link-to
                    class="d-inline-block px-10 py-10"
                    :route_params="{id: benefit.id}"
                    :route_name="route_names.benefit_package">
                  <edit-icon/>
                </router-link-to>
              </td>
            </tr>
          </template>
        </tables-slot>
      </default-box>

    </div>
    <notifier-block/>
  </div>
</template>

<script>

import TablesSlot from "../../small_components/tables/TablesSlot.vue";
import DefaultBox from "../../slots/DefaultBox.vue";
import SearchInput from "../../small_components/SearchInput.vue";
import RouterLinkTo from "../../small_components/RouterLinkTo.vue";
import EditIcon from "../../icons/EditIcon.vue";
import Switcher from "../../small_components/Switcher.vue";
import AsideDashboard from "../../small_components/AsideDashboard.vue";
import HeaderBlock from "../../parts/HeaderBlock.vue";
import NotifierBlock from "../../parts/NotifierBlock.vue";
import {axiosBelts, axiosBenefits, axiosCommittees, axiosUsers} from "../../../helpers/axios_requests";
import calendar_mixin from "../../../mixins/calendar_mixin";
import routes_mixin from "../../../mixins/routes_mixin";

export default {
  mixins: [calendar_mixin, routes_mixin],

  name: 'BenefitsLayout',
  components: {
    NotifierBlock,
    HeaderBlock,
    AsideDashboard,
    Switcher,
    EditIcon,
    RouterLinkTo,
    SearchInput,
    DefaultBox,
    TablesSlot,

  },

  computed: {
  },
  beforeMount() {
  },

  data() {
    return {
      getUserRoleIsAdmin: true,
      loading: true,
      search: '',
      benefits: [],
      pagination: [],
    }
  },

  created() {
    this.loading = false;
    this.fetchList()
  },
  methods: {
    searchFetchList() {
      return true;
    },

    fillData({collection, pagination}) {
      this.benefits = collection || []
      this.pagination = pagination || []
    },

    fetchList() {
      this.loading = true
      axiosBelts.list()
          .then(r => {
            this.fillData(r.data)
          })
          .finally(() => {
            this.loading = false
          })
    },
  }
}
</script>
